class BundleQuantityInput extends HTMLElement {

    constructor() {
        super();
        try {
            this.i18n = JSON.parse(this.querySelector('[data-i18n-keys]').innerText);
        } catch (err) {
            this.i18n = {};
        }
        this.data = document.getElementById('product-bundle-config');
        this.bundleDiscountInfo = this.querySelector('[data-bundle-discount-info]');
        this.bundleDiscountInfoPrice = this.bundleDiscountInfo.querySelector('[data-price]');
        this.bundleDiscountInfoCompareAtPrice = this.bundleDiscountInfo.querySelector('[data-compare-at-price]');
        this.bundleDiscountInfoPercent = this.bundleDiscountInfo.querySelector('[data-percent]');
        this.lineItemProperties = this.querySelector('[data-line-item-properties]');

        this.select = this.querySelector('select');
        try {
            this.data = JSON.parse(this.data.innerText);
        } catch (err) {
            this.data = [];
            this.remove();
        }

        if (this.data.length) {
            this.data = this.data.sort((a, b) => a.quantity - b.quantity);
            this.data.forEach(this.insertSelectOption.bind(this));
            this.setupEventListeners();
            this.updateDiscountInfo(this.select);
            this.setLineItemProperties(this.select);
        }
    }

    insertSelectOption({ quantity, singlePriceMoney }) {
        let selected = '';
        if (quantity == 1) {
            selected = 'selected';
        }
        this.select.insertAdjacentHTML('beforeend', `
            <option ${selected} value="${quantity}">${quantity} – ${this.i18n['products.product.bundle.quantity_input.unit_price']} ${singlePriceMoney}</option>
        `);
    }

    setupEventListeners() {
        this.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange(event) {
        this.updateDiscountInfo(event.target);
        this.setLineItemProperties(event.target);
    }

    updateDiscountInfo(select) {
        const quantity = parseFloat(select.value);
        const selectedTier = this.data.find(tier => tier.quantity == quantity);
        this.bundleDiscountInfoPrice.innerHTML = selectedTier.totalPriceMoney;
        if (quantity > 1) {
            this.bundleDiscountInfoCompareAtPrice.innerHTML = selectedTier.totalCompareAtPriceMoney;
            this.bundleDiscountInfoPercent.innerHTML = `${selectedTier.discountRounded}% ${this.i18n['products.product.bundle.quantity_input.off']}`;
        } else {
            this.bundleDiscountInfoCompareAtPrice.innerHTML = '';
            this.bundleDiscountInfoPercent.innerHTML = '';
        }
    }

    setLineItemProperties(select) {
        const quantity = parseFloat(select.value);
        const selectedTier = this.data.find(tier => tier.quantity == quantity);
        this.lineItemProperties.querySelector('[name="properties\[_bundle_discount\]"]').value = selectedTier.discount;
    }

    remove() {
        while (this.firstChild) {
            this.removeChild(this.firstChild);
        }
    }

}

customElements.define('bundle-quantity-input', BundleQuantityInput);